/* PledgeWear Shopify Theme — theme.js */

/* ── ORG COLOR MAP ────────────────────────────────────────────────────────── */
const ORG_COLORS = {
  'alpha-phi-alpha':   '#CFB53B',
  'kappa-alpha-psi':   '#CC0000',
  'omega-psi-phi':     '#4B0082',
  'phi-beta-sigma':    '#003087',
  'iota-phi-theta':    '#4A3728',
  'alpha-kappa-alpha': '#006B3F',
  'delta-sigma-theta': '#AA0000',
  'zeta-phi-beta':     '#1565C0',
  'sigma-gamma-rho':   '#003DA5',
};

/* ── SET ORG ACCENT COLOR ─────────────────────────────────────────────────── */
function setOrgColor() {
  var bodyOrg = document.body.dataset.orgSlug;
  if (bodyOrg && ORG_COLORS[bodyOrg]) {
    document.documentElement.style.setProperty('--org', ORG_COLORS[bodyOrg]);
    document.documentElement.style.setProperty('--org-dim', ORG_COLORS[bodyOrg] + '22');
  }
}

/* ── MOBILE NAV ───────────────────────────────────────────────────────────── */
function initNav() {
  var ham = document.getElementById('nav-ham');
  var links = document.getElementById('nav-links');
  if (ham && links) {
    ham.addEventListener('click', function() {
      links.classList.toggle('open');
      ham.textContent = links.classList.contains('open') ? '✕' : '☰';
    });
    // Mobile: dropdown accordions expand on first tap of the label
    var mobileMQ = window.matchMedia('(max-width:960px)');
    links.querySelectorAll('[data-nav-dd] > a').forEach(function(topA) {
      topA.addEventListener('click', function(e) {
        var parent = topA.parentElement;
        if (mobileMQ.matches && !parent.classList.contains('is-open')) {
          e.preventDefault();
          // Close siblings
          links.querySelectorAll('[data-nav-dd].is-open').forEach(function(sib) {
            if (sib !== parent) sib.classList.remove('is-open');
          });
          parent.classList.add('is-open');
        }
      });
    });
    // Close nav on link click — but only for real leaf links, not the top dropdown label first-tap
    links.querySelectorAll('a').forEach(function(a) {
      a.addEventListener('click', function(e) {
        var parent = a.parentElement;
        // Skip if this is a top-level dropdown label AND we're on mobile AND dropdown just opened
        if (mobileMQ.matches && parent && parent.hasAttribute && parent.hasAttribute('data-nav-dd') && a === parent.firstElementChild) return;
        links.classList.remove('open');
        ham.textContent = '☰';
      });
    });
    // Close on outside click
    document.addEventListener('click', function(e) {
      if (!ham.contains(e.target) && !links.contains(e.target)) {
        links.classList.remove('open');
        ham.textContent = '☰';
      }
    });
  }
}

/* ── FAQ ACCORDION ────────────────────────────────────────────────────────── */
function initFaq() {
  document.querySelectorAll('.faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = q.parentElement;
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
}

/* Section-specific helpers (custom-orders fstep/fsubmit, shop filters, collection
   filters, ambassador form, PDP image swap) live inside their own sections now —
   they only execute when those sections are rendered. */

/* ── TOAST ────────────────────────────────────────────────────────────────── */
/* ── WISHLIST — localStorage-backed save-for-later ────────────────────────
   Stored as: { handle: { handle, title, url, image, price, savedAt } }
   Read via pwWishlist.get(), pwWishlist.has(handle), pwWishlist.toggle({...})
*/
var pwWishlist = (function() {
  var KEY = 'pw_wishlist_v1';
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
  }
  function save(obj) {
    try { localStorage.setItem(KEY, JSON.stringify(obj)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('pw:wishlist-changed', { detail: obj }));
  }
  return {
    get:    function() { return load(); },
    has:    function(handle) { return !!load()[handle]; },
    add:    function(item) { var d = load(); d[item.handle] = Object.assign({ savedAt: Date.now() }, item); save(d); },
    remove: function(handle) { var d = load(); delete d[handle]; save(d); },
    toggle: function(item) {
      var d = load();
      if (d[item.handle]) { delete d[item.handle]; save(d); return false; }
      d[item.handle] = Object.assign({ savedAt: Date.now() }, item);
      save(d);
      return true;
    },
    count:  function() { return Object.keys(load()).length; }
  };
})();

/* Wire up [data-wishlist-toggle] buttons + keep their visual state in sync */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;
  e.preventDefault();
  var handle = btn.dataset.productHandle;
  if (!handle) return;
  var item = {
    handle: handle,
    title:  btn.dataset.productTitle  || '',
    url:    btn.dataset.productUrl    || '',
    image:  btn.dataset.productImage  || '',
    price:  btn.dataset.productPrice  || ''
  };
  var added = pwWishlist.toggle(item);
  pwSyncWishlistButtons();
  if (typeof showToast === 'function') {
    showToast(added ? 'Saved to wishlist' : 'Removed from wishlist');
  }
  // Fire Klaviyo custom event so wishlist-based segments / flows can be built.
  // Only "added" fires — removals aren't usually marketing-actionable.
  if (added && window.klaviyo && typeof window.klaviyo.push === 'function') {
    window.klaviyo.push(['track', 'Added to Wishlist', {
      ProductName: item.title,
      ProductHandle: item.handle,
      ProductUrl: window.location.origin + item.url,
      ProductImage: item.image,
      Price: item.price
    }]);
  }
});

function pwSyncWishlistButtons() {
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
    var saved = pwWishlist.has(btn.dataset.productHandle);
    btn.classList.toggle('is-saved', saved);
    btn.textContent = saved ? '♥  Saved' : '♡  Save for Later';
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
  });
  // Update header counter (if a [data-wishlist-count] element exists)
  document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
    var n = pwWishlist.count();
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
}
/* Defer wishlist DOM sync to idle time — not blocking first paint.
   Falls back to setTimeout in browsers without requestIdleCallback (Safari). */
function pwIdle(fn) {
  if (typeof requestIdleCallback === 'function') requestIdleCallback(fn);
  else setTimeout(fn, 200);
}
document.addEventListener('DOMContentLoaded', function() { pwIdle(pwSyncWishlistButtons); });
document.addEventListener('pw:wishlist-changed', pwSyncWishlistButtons);

/* ── RECENTLY VIEWED — localStorage track + render strip ───────────────────
   Tracks last 8 products viewed. Renders into any [data-recently-viewed]
   container as a horizontal scroll strip. Excludes the current page's product. */
var pwRecentlyViewed = (function() {
  var KEY = 'pw_recent_v1', MAX = 8;
  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function save(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  return {
    track: function(p) {
      if (!p || !p.handle) return;
      var arr = load().filter(function(x) { return x.handle !== p.handle; });
      arr.unshift({ handle: p.handle, title: p.title, url: p.url, image: p.image, price: p.price, viewedAt: Date.now() });
      save(arr.slice(0, MAX));
    },
    get: function() { return load(); }
  };
})();

function pwRenderRecentlyViewed() {
  var wraps = document.querySelectorAll('[data-recently-viewed]');
  if (!wraps.length) return;
  var items = pwRecentlyViewed.get();
  var excludeHandle = document.body.dataset.productHandle || '';
  items = items.filter(function(p) { return p.handle !== excludeHandle; });
  if (!items.length) { wraps.forEach(function(w) { w.style.display = 'none'; }); return; }

  var html = items.map(function(p) {
    return '<a href="' + pwEsc(p.url) + '" class="pw-recent-card">'
      + (p.image ? '<div class="pw-recent-img"><img src="' + pwImg(p.image, 400) + '" alt="' + pwEsc(p.title) + '" loading="lazy"></div>' : '<div class="pw-recent-img"></div>')
      + '<div class="pw-recent-info">'
      + '<p class="pw-recent-name">' + pwEsc(p.title) + '</p>'
      + '<p class="pw-recent-price">' + pwEsc(p.price || '') + '</p>'
      + '</div>'
      + '</a>';
  }).join('');

  wraps.forEach(function(w) {
    w.querySelector('[data-recently-viewed-content]').innerHTML = html;
    w.style.display = '';
  });
}
document.addEventListener('DOMContentLoaded', function() { pwIdle(pwRenderRecentlyViewed); });

/* ── PRODUCT CARD COLOR SWATCH HOVER → swap card image ────────────────────
   Each [data-pcard-img] swatch has a variant image URL. On mouseenter, swap
   the card's <img>. On mouseleave, restore the original. */
document.addEventListener('mouseover', function(e) {
  var sw = e.target.closest('.pcard-swatch[data-pcard-img]');
  if (!sw) return;
  var card = sw.closest('.pcard');
  if (!card) return;
  var img = card.querySelector('.pcard-img');
  if (!img || img.tagName !== 'IMG') return;
  if (!img.dataset.origSrc) img.dataset.origSrc = img.src;
  img.src = sw.dataset.pcardImg;
});
document.addEventListener('mouseout', function(e) {
  var sw = e.target.closest('.pcard-swatch[data-pcard-img]');
  if (!sw) return;
  var card = sw.closest('.pcard');
  if (!card) return;
  // Only restore if leaving the swatch row entirely (mouseout fires on every move)
  var related = e.relatedTarget;
  if (related && card.contains(related) && related.closest('.pcard-swatches')) return;
  var img = card.querySelector('.pcard-img');
  if (img && img.dataset.origSrc) img.src = img.dataset.origSrc;
});

function showToast(msg) {
  var t = document.getElementById('cart-toast');
  if (!t) {
    t = document.createElement('div');
    t.id = 'cart-toast';
    t.className = 'cart-toast';
    document.body.appendChild(t);
  }
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 2500);
}

/* ── CART DRAWER ──────────────────────────────────────────────────────────── */
function pwFmt(cents) {
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents);
  }
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function pwEsc(s) {
  return String(s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function pwImg(src, w) {
  if (!src) return '';
  return src.split('?')[0] + '?width=' + w;
}

function pwUpdateCount(n) {
  document.querySelectorAll('[data-cart-count]').forEach(function(el) {
    el.textContent = n;
    el.style.display = n > 0 ? 'flex' : 'none';
  });
}

// Element that had focus before the drawer opened — restored on close
var pwLastFocusedEl = null;

function pwOpenCart() {
  var drawer  = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer) return;
  pwLastFocusedEl = document.activeElement; // remember for return focus
  drawer.classList.add('is-open');
  drawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('is-open');
  document.body.classList.add('drawer-open');
  pwRefreshCart();
  // Move focus into the drawer (close button) once the slide-in transition starts
  setTimeout(function() {
    var closeBtn = drawer.querySelector('[data-cart-close]');
    if (closeBtn) closeBtn.focus();
  }, 60);
}

function pwCloseCart() {
  var drawer  = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  if (drawer)  { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
  if (overlay) overlay.classList.remove('is-open');
  document.body.classList.remove('drawer-open');
  // Return focus to whatever opened the drawer (typically the cart toggle button)
  if (pwLastFocusedEl && typeof pwLastFocusedEl.focus === 'function') {
    try { pwLastFocusedEl.focus(); } catch (e) {}
    pwLastFocusedEl = null;
  }
}

/* Trap focus inside the drawer when it's open. Tab/Shift+Tab cycles through
   the drawer's focusable elements; outside elements stay unreachable. */
function pwTrapFocus(e) {
  if (e.key !== 'Tab') return;
  var drawer = document.querySelector('[data-cart-drawer].is-open');
  if (!drawer) return;
  var focusable = drawer.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
  );
  if (!focusable.length) return;
  var first = focusable[0], last = focusable[focusable.length - 1];
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault(); last.focus();
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault(); first.focus();
  }
}
document.addEventListener('keydown', pwTrapFocus);

function pwRefreshCart() {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      pwRenderCart(cart);
      pwUpdateCount(cart.item_count);
      // Notify other components (shipping bar, etc.)
      document.dispatchEvent(new CustomEvent('pw:cart-changed', { detail: cart }));
      return cart;
    })
    .catch(function() {});
}

function pwRenderCart(cart) {
  var content = document.querySelector('[data-cart-drawer-content]');
  var footer  = document.querySelector('[data-cart-footer]');
  var countEl = document.querySelector('[data-cart-title-count]');
  var subEl   = document.querySelector('[data-cart-subtotal]');
  var upsell  = document.querySelector('[data-cart-upsell]');
  if (!content) return;

  if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';

  if (cart.item_count === 0) {
    content.innerHTML = '<div class="cart-drawer-empty" data-cart-empty>'
      + '<p class="cart-drawer-empty-title">Bag is <span>empty</span></p>'
      + '<p class="cart-drawer-empty-sub">Add something fresh to get started.</p>'
      + '<a href="/collections/all" class="cart-drawer-empty-btn" data-cart-close>Shop Now</a>'
      + '</div>';
    if (footer) footer.style.display = 'none';
    if (upsell) upsell.style.display = 'none';
    return;
  }

  var html = '';
  cart.items.forEach(function(item) {
    var imgHtml = item.image
      ? '<a href="' + pwEsc(item.url) + '" class="cart-drawer-item-img"><img src="' + pwImg(item.image, 200) + '" alt="' + pwEsc(item.product_title) + '" loading="lazy"></a>'
      : '<div class="cart-drawer-item-img"></div>';
    var varHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cart-drawer-item-variant">' + pwEsc(item.variant_title) + '</p>'
      : '';
    // Line item properties (e.g., custom Line Name / Back Number from PDP)
    var propsHtml = '';
    if (item.properties && typeof item.properties === 'object') {
      var propRows = [];
      Object.keys(item.properties).forEach(function(k) {
        var v = item.properties[k];
        if (k.charAt(0) === '_') return; // skip private/hidden props
        if (v === null || v === '' || typeof v === 'undefined') return;
        propRows.push(
          '<li><span class="cart-drawer-item-prop-key">' + pwEsc(k) + ':</span> '
          + '<span class="cart-drawer-item-prop-val">' + pwEsc(v) + '</span></li>'
        );
      });
      if (propRows.length) {
        propsHtml = '<ul class="cart-drawer-item-props">' + propRows.join('') + '</ul>';
      }
    }
    html += '<div class="cart-drawer-item">'
      + imgHtml
      + '<div>'
      + '<p class="cart-drawer-item-vendor">' + pwEsc(item.vendor) + '</p>'
      + '<a href="' + pwEsc(item.url) + '" class="cart-drawer-item-name">' + pwEsc(item.product_title) + '</a>'
      + varHtml
      + propsHtml
      + '<div class="cart-drawer-item-bottom">'
      + '<span class="cart-drawer-item-price">' + pwFmt(item.final_line_price) + '</span>'
      + '<div class="cart-drawer-item-controls">'
      + '<div class="cart-drawer-qty">'
      + '<button type="button" class="cart-drawer-qty-btn" data-cart-qty="' + pwEsc(item.key) + '" data-qty="' + (item.quantity - 1) + '">−</button>'
      + '<span class="cart-drawer-qty-num">' + item.quantity + '</span>'
      + '<button type="button" class="cart-drawer-qty-btn" data-cart-qty="' + pwEsc(item.key) + '" data-qty="' + (item.quantity + 1) + '">+</button>'
      + '</div>'
      + '<button type="button" class="cart-drawer-remove" data-cart-qty="' + pwEsc(item.key) + '" data-qty="0">Remove</button>'
      + '</div>'
      + '</div>'
      + '</div>'
      + '</div>';
  });
  content.innerHTML = html;

  if (subEl) subEl.textContent = pwFmt(cart.total_price);
  if (footer) footer.style.display = '';

  var FREE_SHIP = 15000;
  var fillEl = document.querySelector('[data-cart-ship-fill]');
  var noteEl = document.querySelector('[data-cart-ship-note]');
  if (fillEl && noteEl) {
    var pct = Math.min(100, Math.round((cart.total_price / FREE_SHIP) * 100));
    fillEl.style.width = pct + '%';
    noteEl.textContent = cart.total_price >= FREE_SHIP
      ? 'You qualify for free shipping!'
      : pwFmt(FREE_SHIP - cart.total_price) + ' away from free shipping';
  }

  // Load product recommendations based on first cart item
  pwLoadRecommendations(cart.items[0] && cart.items[0].product_id, cart);
}

/* ── OTHERS ALSO BOUGHT — Shopify recommendations API ────────────────────── */
function pwLoadRecommendations(productId, cart) {
  var wrap    = document.querySelector('[data-cart-upsell]');
  var content = document.querySelector('[data-cart-upsell-content]');
  if (!wrap || !content || !productId) return;

  // Build a set of product IDs already in the cart so we can filter them out
  var inCart = {};
  if (cart && cart.items) {
    cart.items.forEach(function(it) { inCart[it.product_id] = true; });
  }

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var url  = root + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=related';

  fetch(url, { headers: { Accept: 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var prods = (data && data.products) || [];
      // Filter out anything already in the cart
      prods = prods.filter(function(p) { return !inCart[p.id]; }).slice(0, 6);
      if (!prods.length) { wrap.style.display = 'none'; return; }

      var html = '';
      prods.forEach(function(p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var imgUrl = typeof img === 'string' ? img : (img.src || '');
        var firstAvail = (p.variants || []).find(function(v) { return v.available; }) || (p.variants && p.variants[0]) || {};
        var vid = firstAvail.id || '';
        if (!vid) return;
        html += '<div class="cart-drawer-upsell-card">'
          + '<a href="' + pwEsc(p.url || ('/products/' + p.handle)) + '" class="cart-drawer-upsell-card-img">'
          + (imgUrl ? '<img src="' + pwImg(imgUrl, 300) + '" alt="' + pwEsc(p.title) + '" loading="lazy">' : '')
          + '</a>'
          + '<div class="cart-drawer-upsell-card-info">'
          + '<div class="cart-drawer-upsell-card-meta">'
          + '<a href="' + pwEsc(p.url || ('/products/' + p.handle)) + '" class="cart-drawer-upsell-card-name">' + pwEsc(p.title) + '</a>'
          + '<span class="cart-drawer-upsell-card-price">' + pwFmt(p.price) + '</span>'
          + '</div>'
          + '<button type="button" class="cart-drawer-upsell-add" data-quick-add data-variant-id="' + vid + '" aria-label="Add ' + pwEsc(p.title) + '">+</button>'
          + '</div>'
          + '</div>';
      });
      content.innerHTML = html;
      wrap.style.display = html ? '' : 'none';
    })
    .catch(function() { wrap.style.display = 'none'; });
}

/* ── ADD TO CART — single source of truth ─────────────────────────────────
   Accepts:
     { variantId, quantity, properties, button, openDrawer, onSuccess, onError }
   OR
     { formData, button, openDrawer, onSuccess, onError }
   Returns: Promise that resolves with the cart-add response or rejects with
   the Shopify error object. Manages button text/disabled state, refreshes
   the cart drawer, and opens it (unless openDrawer:false).
*/
function pwAddToCart(opts) {
  opts = opts || {};
  var btn      = opts.button || null;
  var origText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

  var fetchOpts = { method: 'POST', headers: { Accept: 'application/json' } };
  if (opts.formData) {
    fetchOpts.body = opts.formData;
  } else {
    var item = { id: parseInt(opts.variantId, 10), quantity: opts.quantity || 1 };
    if (opts.properties) item.properties = opts.properties;
    fetchOpts.headers['Content-Type'] = 'application/json';
    fetchOpts.body = JSON.stringify({ items: [item] });
  }

  return fetch('/cart/add.js', fetchOpts)
    .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
    .then(function(res) {
      var data = res.data;
      // Shopify returns { status: 422, ... } on errors
      if (data && data.status) {
        if (btn) { btn.textContent = origText; btn.disabled = false; }
        if (typeof opts.onError === 'function') opts.onError(data);
        else if (typeof showToast === 'function') showToast(data.description || data.message || 'Could not add to cart');
        return Promise.reject(data);
      }
      if (btn) {
        btn.textContent = 'Added ✓';
        btn.disabled = false;
        setTimeout(function() { btn.textContent = origText; }, 1500);
      }
      pwRefreshCart();
      if (opts.openDrawer !== false) pwOpenCart();
      if (typeof opts.onSuccess === 'function') opts.onSuccess(data);
      return data;
    })
    .catch(function(err) {
      if (btn) { btn.textContent = origText; btn.disabled = false; }
      if (typeof opts.onError === 'function' && err && !err.status) opts.onError(err);
      return Promise.reject(err);
    });
}

/* ── CART EVENT DELEGATION ────────────────────────────────────────────────── */
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-cart-toggle]')) {
    e.preventDefault();
    pwOpenCart();
    return;
  }
  if (e.target.closest('[data-cart-close]')) {
    pwCloseCart();
    return;
  }
  var qtyBtn = e.target.closest('[data-cart-qty]');
  if (qtyBtn) {
    var key = qtyBtn.dataset.cartQty;
    var qty = parseInt(qtyBtn.dataset.qty, 10);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { pwRenderCart(cart); pwUpdateCount(cart.item_count); })
    .catch(function() {});
    return;
  }
  var qaBtn = e.target.closest('[data-quick-add]');
  if (qaBtn) {
    e.preventDefault();
    var vid = qaBtn.dataset.variantId;
    if (!vid) return;
    pwAddToCart({ variantId: vid, button: qaBtn });
    return;
  }
});

/* ── PRODUCT FORM INTERCEPT (document-level fallback) ──────────────────── */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form || !form.action) return;
  if (form.action.indexOf('cart/add') === -1) return;
  e.preventDefault();
  pwAddToCart({ formData: new FormData(form), button: form.querySelector('[type="submit"]') });
});

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') pwCloseCart();
});

/* ── INIT ─────────────────────────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function() {
  setOrgColor();
  initNav();
  initFaq();
});
